import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'RESERVATIONS_SHOW', {
  TITLE: 'Reservation Information',
  PERSON: 'Applicant',
  FAMILY: 'Family',
  CHILDREN: 'Children',
  LOCATION: 'Location',
  MANAGER: 'Manager',
  PAYMENT: 'Payment',
  COMMENTS: 'Comments',
  PERSON_INFORMATION: 'Applicant information',
  FAMILY_INFORMATION: 'Family information',
  CHILDREN_INFORMATION: 'Children information',
  LOCATION_INFORMATION: 'Location information',
  MANAGER_INFORMATION: 'Manager information',
  PAYMENT_INFORMATION: 'Payment information',
  NAME: 'First name',
  LAST_NAME: 'Last name',
  ID_CARD_TYPE: 'ID Card type',
  ID_CARD: 'ID Card',
  ID_CARD_FILE: 'ID Card File (scanned)',
  ID_CARD_BACK_FILE: 'ID Card Back File (scanned)',
  ADDRESS: 'Address',
  AGE: 'Age',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  COMMUNITY: 'Community',
  CIVIL_STATE: 'Civil state',
  WEDDING_TEMPLE: 'Wedding temple',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Marriage certificate',
  GET_FILE: 'Get',
  SPOUSE_INFO: 'Spouse information',
  FATHER_INFO: 'Father information',
  MOTHER_INFO: 'Mother information',
  CHILDREN_INFO: 'Children information',
  CEMENTERY: 'Cemetery',
  PLOT: 'Plot',
  RELATIONSHIP: 'Relationship with the applicant',
  CURRENCY: 'Currency',
  AMOUNT: 'Amount',
  PAYMENT_METHOD: 'Payment method',
  LOADING: 'Loading...',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'RESERVATIONS_SHOW', {
  TITLE: 'Información de la reserva',
  PERSON: 'Solicitante',
  FAMILY: 'Familiares',
  CHILDREN: 'Hijos',
  LOCATION: 'Ubicación',
  MANAGER: 'Destinatario',
  PAYMENT: 'Pago',
  COMMENTS: 'Observaciones',
  PERSON_INFORMATION: 'Información del solicitante',
  FAMILY_INFORMATION: 'Información de los familiares',
  CHILDREN_INFORMATION: 'Información de los hijos',
  LOCATION_INFORMATION: 'Ubicación de la reserva',
  MANAGER_INFORMATION: 'Información del destinatario',
  PAYMENT_INFORMATION: 'Información de pago',
  NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  ID_CARD_FILE: 'Documento frente (escaneado)',
  ID_CARD_BACK_FILE: 'Documento dorso (escaneado)',
  ADDRESS: 'Domicilio',
  AGE: 'Edad',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  COMMUNITY: 'Comunidad',
  CIVIL_STATE: 'Estado civil',
  WEDDING_TEMPLE: 'Templo donde se casó',
  KETUBA_FILE: 'Ketubá',
  MARRIAGE_CERTIFICATE_FILE: 'Libreta de casamiento',
  GET_FILE: 'Get',
  SPOUSE_INFO: 'Información del/la cónyuge',
  FATHER_INFO: 'Información del padre',
  MOTHER_INFO: 'Información de la madre',
  CHILDREN_INFO: 'Información de los hijos',
  CEMENTERY: 'Cementerio',
  PLOT: 'Parcela',
  RELATIONSHIP: 'Relación con el solicitante',
  CURRENCY: 'Moneda',
  AMOUNT: 'Importe',
  PAYMENT_METHOD: 'Forma de pago',
  LOADING: 'Cargando...',
});
